import {ADMIN_CONFIG} from "@shared/config/admin.config";

export const ADMIN_MENU: { link: string, icon: string, label: string }[] = [
  {
    link: `${ADMIN_CONFIG.adminBaseUrl}/dashboard`,
    icon: 'faHouse',
    label: 'Tableau de bord'
  },
  {
    link: `${ADMIN_CONFIG.adminBaseUrl}/catalogue`,
    icon: 'faCubesStacked',
    label: 'Catalogue'
  },
  {
    link: `${ADMIN_CONFIG.adminBaseUrl}/commerce`,
    icon: 'faBasketShopping',
    label: 'Commerce'
  },
  {
    link: `${ADMIN_CONFIG.adminBaseUrl}/content-marketing`,
    icon: 'faFileText',
    label: 'Contenu & Marketing'
  },
  {
    link: `${ADMIN_CONFIG.adminBaseUrl}/clients-support`,
    icon: 'faUsers',
    label: 'Clients & Support'
  },
  {
    link: `${ADMIN_CONFIG.adminBaseUrl}/analytics`,
    icon: 'faChartLine',
    label: 'Analytics'
  },
  {
    link: `${ADMIN_CONFIG.adminBaseUrl}/settings`,
    icon: 'faGear',
    label: 'Paramètres'
  }
];

